module.exports = __webpack_public_path__ + "img/icon_qustion_bank2.671de0b8.svg";